@if (open()) {
  <div class="comment-modal" role="dialog" aria-modal="true" aria-label="Add comment">
    <button type="button" class="comment-modal__backdrop" aria-label="Close" (click)="closed.emit()"></button>
    <div class="comment-modal__panel">
      <header class="comment-modal__header">
        <h3 class="comment-modal__title">Add comment</h3>
        <button type="button" class="comment-modal__close" aria-label="Close" (click)="closed.emit()">
          <i class="pi pi-times"></i>
        </button>
      </header>
      <textarea
        class="comment-modal__textarea"
        rows="4"
        placeholder="Write a comment…"
        [value]="draft()"
        [disabled]="saving()"
        (input)="onInput($event)"></textarea>
      @if (error()) {
        <p class="comment-modal__error">Couldn’t save your comment. Please try again.</p>
      }
      <footer class="comment-modal__actions">
        <button
          type="button"
          class="iopoc-button small secondary"
          [disabled]="saving()"
          (click)="closed.emit()">
          Cancel
        </button>
        <button
          type="button"
          class="iopoc-button small primary"
          [disabled]="saving() || !draft().trim()"
          (click)="saveRequested.emit()">
          {{ saving() ? 'Saving…' : 'Save' }}
        </button>
      </footer>
    </div>
  </div>
}
